import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
//services
import { StoreService } from 'src/app/services/store.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  data: Observable<any>;
  areas: any;
  today: number = Date.now();
  weekDayNo: number;
  restaurant_address: string;
  restaurant_address_for_view: string;

  isShowScheduleClick = false;
  footerSchedule: any;

  footerScheduleRaw: any[] = [];

    constructor(
        private store: StoreService,
        private http: HttpService,
        private sharedService: SharedService,
        @Inject(PLATFORM_ID) private readonly platformId: any,
        private elementRef: ElementRef
    ) {
    }

    ngOnInit() {
      const today = new Date();
      this.weekDayNo = today.getDay();
      if (this.platformId === 'browser') {
        this.data = this.store.restaurantData;
        this.data.subscribe(d => {
            if (Object.getOwnPropertyNames(d).length !== 0) {
              const resId = d?.restaurant_data?.restaurant_id;
              
              let res_postcode = '';
              let res_postcode_for_view = '';

              if (d.restaurant_data.restaurant_name) {
                res_postcode = res_postcode.concat(d.restaurant_data.restaurant_name.trim());
              }
              if (d.restaurant_data.street_address) {
                res_postcode = res_postcode.concat(', ' + d.restaurant_data.street_address.replace(/,\s*$/, '').trim());
                res_postcode_for_view = res_postcode_for_view.concat(', ' + d.restaurant_data.street_address.replace(/,\s*$/, '').trim());
              }
              if (d.restaurant_data.local_area) {
                res_postcode = res_postcode.concat(', ' + d.restaurant_data.local_area.replace(/,\s*$/, '').trim());
                res_postcode_for_view = res_postcode_for_view.concat(', ' + d.restaurant_data.local_area.replace(/,\s*$/, '').trim());
              }
              if (d.restaurant_data.city_or_town) {
                res_postcode = res_postcode.concat(', ' + d.restaurant_data.city_or_town.replace(/,\s*$/, '').trim());
                res_postcode_for_view = res_postcode_for_view.concat(', ' + d.restaurant_data.city_or_town.replace(/,\s*$/, '').trim());
              }
              if (d.restaurant_data.postcode) {
                res_postcode = res_postcode.concat(' ' + d.restaurant_data.postcode.trim());
                res_postcode_for_view = res_postcode_for_view.concat(' ' + d.restaurant_data.postcode.trim());
              }
              this.restaurant_address = res_postcode.replace(/^,/, '').trim();
              this.restaurant_address_for_view = res_postcode_for_view.replace(/^,/, '').trim();

              //get Delivery areas
              this.areas = d.restaurant_delivery_areas;

              // Using IntersectionObserver to detect when the footer is visible
              const observer = new IntersectionObserver(
                (entries) => {
                  const footerEntry = entries[0];
                  if (footerEntry.isIntersecting) {
                    // Call the API when the footer is visible
                    this.loadFooterSchedule(resId);
                    observer.disconnect();
                  }
                },
                { threshold: 0.1 } // Trigger when at least 10% of the footer is visible
              );
              observer.observe(this.elementRef.nativeElement);
            }
        });
      }
    }

    showScheduleClick(){
      this.isShowScheduleClick = !this.isShowScheduleClick
    }

    //  Load restaurant opening schedule
    loadFooterSchedule(resId: any): void {
      this.http.fetchRestaurantSchedule(resId).subscribe((res: any) => {
        if (res && res.status) {
          const rawSchedule = res?.data || [];
          this.footerScheduleRaw = rawSchedule;
          const formattedData = this.sharedService.formattedFullSchedule(rawSchedule);
          this.footerSchedule = formattedData.sort((a: any, b: any) => {
            const orderA = a.dayOfWeek === 0 ? 7 : a.dayOfWeek;
            const orderB = b.dayOfWeek === 0 ? 7 : b.dayOfWeek;
            return orderA - orderB;
          });
        }
      });
    }

    getFooterTodaySchedule(): string {
      if (!this.footerScheduleRaw || this.footerScheduleRaw.length === 0) {
        return '';
      }
      return this.sharedService.getScheduleDisplayLabel(this.footerScheduleRaw);
    }

    getFooterTodayScheduleItems(): string[] {
      const schedule = this.getFooterTodaySchedule();
      if (!schedule) {
        return [];
      }
      return schedule.split(',').map((item: string) => item.trim()).filter(Boolean);
    }

    getFooterScheduleLabelItems(label: string): string[] {
      if (!label) {
        return [];
      }
      return label.split(',').map((item: string) => item.trim()).filter(Boolean);
    }

}
